import { getEventTracker } from '@libs/eventTracking'
import {
  getCurrentPagePropertyFor,
  getNextPagePropertyFor,
} from '@libs/eventTracking/eventPropertyUtils'
import { WebEventNames } from './common'
import { PageName } from '@app-core/eventTracking/PageName'

interface TrackWebCategoryECPromotionEnterPopselectProducts {
  category: string
  toPageUrl: string
  title: string
}

export function trackWebCategoryECPromotionEnterPopselectProducts({
  category,
  toPageUrl,
  title,
}: TrackWebCategoryECPromotionEnterPopselectProducts) {
  getEventTracker().track({
    name: WebEventNames.WEB_CATEGORY_EC_PROMOTION_ENTER_POPSELECT_PRODUCTS,
    properties: {
      currentPage: getCurrentPagePropertyFor(PageName.WEB_CATEGORY),
      toPage: getNextPagePropertyFor({
        pageUrl: toPageUrl,
      }),
      title,
      actionTarget: toPageUrl,
      category,
    },
  })
}
